import { useKeycloak } from "@react-keycloak/web";
import qs from "qs";
import { useNavigate } from "react-router-dom";
import apiInputService from "services/apiInputService";
import { keycloakService } from "services/authService";
import { useTokenParsed } from "store/auth/auth-store";

const LOGIN_ENDPOINT = "/token?client_id=account";

type UseLoginReturn = {
  signIn: (email: string, password: string) => Promise<void>;
  logout: () => void;
};

const useLogin = (): UseLoginReturn => {
  const { keycloak } = useKeycloak();
  const { setTokenParsed } = useTokenParsed();
  const navigate = useNavigate();

  async function signIn(email: string, password: string) {
    const data = qs.stringify({
      client_id: process.env.REACT_APP_API_AUTH_CLIENT_ID,
      username: email.trim(),
      password: password.trim(),
      grant_type: "password",
      client_secret: process.env.REACT_APP_API_AUTH_CLIENT_SECRET,
    });

    const loginResponse = await keycloakService.post(LOGIN_ENDPOINT, data);
    const { access_token, refresh_token } = loginResponse.data;

    keycloakService.defaults.headers[
      "Authorization"
    ] = `Bearer ${access_token}`;

    apiInputService.defaults.headers[
      "Authorization"
    ] = `Bearer ${access_token}`;

    await keycloak
      ?.init({
        token: access_token,
        refreshToken: refresh_token,
        checkLoginIframe: false,
      })
      .then((authenticated) => {
        if (authenticated) {
          setTokenParsed(keycloak?.tokenParsed);
          navigate("/app/dashboard");
        }
      });
  }

  function logout() {
    localStorage.clear();
    keycloakService.defaults.headers["Authorization"] = undefined;
    keycloak.logout({ redirectUri: window.location.origin });
  }

  return { signIn, logout };
};

export default useLogin;
